// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1abSw","title":"Info_title__102qp","selects":"Info_selects__1jHxD","requiredAsterisk":"Info_requiredAsterisk__bINa9"};